var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1528 11.5216C11.1528 10.0964 12.3081 8.94116 13.7332 8.94116H26.2666C27.6917 8.94116 28.8469 10.0964 28.8469 11.5216V12.2588C28.8469 12.8696 28.3518 13.3647 27.7411 13.3647C27.1303 13.3647 26.6352 12.8696 26.6352 12.2588V11.5216C26.6352 11.318 26.4701 11.1529 26.2666 11.1529H13.7332C13.5296 11.1529 13.3646 11.318 13.3646 11.5216V28.4784C13.3646 28.682 13.5296 28.847 13.7332 28.847H26.2666C26.4701 28.847 26.6352 28.682 26.6352 28.4784V16.6823C26.6352 16.0716 27.1303 15.5765 27.7411 15.5765C28.3518 15.5765 28.8469 16.0716 28.8469 16.6823V28.4784C28.8469 29.9035 27.6917 31.0588 26.2666 31.0588H13.7332C12.3081 31.0588 11.1528 29.9035 11.1528 28.4784V11.5216Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5338 22.5306C24.9686 22.7953 25.1065 23.3622 24.8419 23.797L23.0468 26.746C22.8972 26.9919 22.6412 27.1537 22.3549 27.1835C22.0686 27.2132 21.7849 27.1075 21.5878 26.8977L20.4339 25.669C20.0855 25.298 20.1038 24.7147 20.4748 24.3663C20.8458 24.0179 21.429 24.0362 21.7774 24.4072L22.1022 24.753L23.2675 22.8387C23.5321 22.4039 24.0991 22.266 24.5338 22.5306Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9451 14.655C15.9451 14.146 16.3577 13.7334 16.8666 13.7334H23.1333C23.6423 13.7334 24.0549 14.146 24.0549 14.655C24.0549 15.1639 23.6423 15.5765 23.1333 15.5765H16.8666C16.3577 15.5765 15.9451 15.1639 15.9451 14.655Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9451 18.3411C15.9451 17.8322 16.3577 17.4196 16.8666 17.4196H23.1333C23.6423 17.4196 24.0549 17.8322 24.0549 18.3411C24.0549 18.8501 23.6423 19.2627 23.1333 19.2627H16.8666C16.3577 19.2627 15.9451 18.8501 15.9451 18.3411Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlans);
export default __webpack_public_path__ + "static/media/ic_plans.5b445d4b21604ad7f66e3bd905991e10.svg";
export { ForwardRef as ReactComponent };